/**
 * Utilities for fetching and managing user sites via the app-switcher API
 */

export type Site = {
	cloudId: string;
	displayName: string;
	url: string;
	avatar?: string;
	org?: {
		id: string;
		displayName: string;
	};
	availableProducts?: Array<{
		productType: string;
		url?: string;
		activationDate?: string;
	}>;
	adminAccess?: boolean;
};

export type SitesResponse = {
	startUrl?: string;
	isPartial: boolean;
	sites: Site[];
};

/**
 * Converts a site to a format suitable for display in a select dropdown
 */
export type SiteOption = {
	value: string; // cloudId
	label: string; // displayName
	url: string; // base URL
	org?: string; // org displayName
	ari?: string; // Atlassian Resource Identifier
};

/**
 * Builds an Atlassian Resource Identifier (ARI) for a site
 * @param cloudId - The site's cloud ID
 * @returns string - ARI in format: ari:cloud:platform::site/{cloudId}
 */
export function buildSiteAri(cloudId: string): string {
	return `ari:cloud:platform::site/${cloudId}`;
}
